import React, { useState } from 'react';
import SingleSelect from '../../SingleSelect/SingleSelect/SingleSelect.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';

const Select = _ref => {
  let {
    isDisabled,
    isGrid,
    options,
    defaultSelection,
    onSelect,
    isFullWidth,
    borderColor,
    hideMenuInnerBorder,
    maxHeightValue,
    placeholder,
    size = sizeOptions.medium
  } = _ref;
  const [selected, setSelected] = useState(defaultSelection);
  const handleSelect = selectedElement => {
    setSelected(selectedElement);
    onSelect(selectedElement);
  };
  return /*#__PURE__*/React.createElement(SingleSelect, {
    isDisabled: isDisabled,
    isGrid: isGrid,
    options: options,
    value: selected,
    onSelect: handleSelect,
    isFullWidth: isFullWidth,
    borderColor: borderColor,
    hideMenuInnerBorder: hideMenuInnerBorder,
    maxHeightValue: maxHeightValue,
    placeholder: placeholder,
    size: size
  });
};
var Select$1 = Select;

export { Select$1 as default };
//# sourceMappingURL=Select.js.map
